import { Popup } from 'semantic-ui-react';
import styled from 'styled-components';
import { floatingComponentStyles } from '../../../../styles/shareableStyles';
import { theme } from '../../../../styles/theme';

export const PopupContainer = styled.div`
  width: 100%;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.15);
  border-radius: 8px;
`;

export const CustomPopup = styled(({ ...props }) => <Popup {...props} />)<{
  $zIndex: number;
}>`
  &&& {
    padding: 0;
    max-width: 480px;
    min-width: 240px;
    z-index: ${({ $zIndex }) => $zIndex};
    ${floatingComponentStyles};
    border: none;
    line-height: normal;
    color: ${theme.colors.secondary800};
    &::before {
      background-color: ${theme.colors.level2};
      box-shadow: none !important;
    }
  }
`;
